import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';

type UseGetCompaniesProps = {
  contactId?: string;
  enabled?: boolean;
};

export const useGetCompanies = ({ contactId, enabled = true }: UseGetCompaniesProps = {}) => {
  return useQuery({
    queryKey: [...QueryKeys.getCompanies, { contactId }],
    queryFn: () => ApiCompanyAndContactsRepository.getCompanies({ contactId }),
    enabled,
  });
};
